import axios from "axios";
import Cookies from 'js-cookie';
// content type   
axios.defaults.headers.common["Content-Type"] = "application/json";

// content type
const token = Cookies.get("authUser") ? JSON.parse(Cookies.get("authUser")).token : null;
const userId = Cookies.get("authUser") ? JSON.parse(Cookies.get("authUser")).userId : null
if (token) {
	axios.defaults.headers.common["Authorization"] = "Bearer " + token;
	axios.defaults.headers.common["user_id"] = userId;
}

// intercepting to capture errors
axios.interceptors.response.use(
	function (response) {
		return response.data ? response.data : response;
	},
	function (error) {
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		let message;
		switch (error.status) {
			case 500:
				message = "Internal Server Error";
				break;
			case 401:
				message = "Invalid credentials";
				break;
			case 404:
				message = "Sorry! the data you are looking for could not be found";
				break;
			default:
				message = error.message || error;
		}
		return Promise.reject(message);
	}
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token, userId) => {
	axios.defaults.headers.common["Authorization"] = "Bearer " + token;
	axios.defaults.headers["user_id"] = userId;
};

class APIClient {
	/**
	 * Fetches data from given url
	 */
	get = (apiUrl, path, params, headers) => {
		let response;

		response = axios.request({
			method: 'GET',
			maxContentLength: Infinity,
			url: apiUrl + path,
			params: params,
			validateStatus: function (status) {
				return status >= 200 && status < 600;
			},
		});


		return response;
	};

	upload = (apiUrl, path, data, params) => {
		const formData = new FormData();
		const keys = Object.keys(data);

		keys.forEach((key) => {
			if (data[key] !== undefined && data[key] !== null) {
				if (Array.isArray(data[key])) {
					data[key].forEach((item => {
						formData.append(key, item);
					}));
				} else {
					formData.append(key, data[key]);
				}
			}
		});
		return axios.request({
			method: 'POST',
			maxBodyLength: Infinity,
			url: apiUrl + path,
			headers: {
				'Content-Type': 'multipart/form-data',
				...params
			},
			data: formData,
			validateStatus: function (status) {
				return status >= 200 && status < 600;
			},
		});
	}
	/**
	 * post given data to url
	 */
	create = (apiUrl, path, data, params) => {
		let body;
		if (Array.isArray(data)) {
			body = data;
		} else {
			body = {};
			const bodyKeys = Object.keys(data);
			bodyKeys.forEach(key => {
				if (data[key] !== undefined && data[key] !== null) {
					body[key] = data[key];
				}
			})
		}

		return axios.request({
			method: 'POST',
			url: apiUrl + path,
			headers: {
				'Content-Type': "application/json",
				...params
			},
			data: body,
			validateStatus: function (status) {
				return status >= 200 && status < 600;
			},
		});
	};
	/**
	 * Updates data
	 */
	update = (apiUrl, path, data) => {
		return axios.patch(apiUrl + path, data);
	};

	put = (apiUrl, path, data, params) => {
		// return axios.put(apiUrl + path, data, params);
		return axios.request({
			method: 'PUT',
			url: apiUrl + path,
			headers: {
				'Content-Type': "application/json",
				...params
			},
			data: data,
			validateStatus: function (status) {
				return status >= 200 && status < 600;
			},
		})
	};
	/**
	 * Delete
	 */
	delete = (apiUrl, path, config) => {
		// return axios.delete(apiUrl + path, { ...config });

		return axios.request({
			method: 'DELETE',
			url: apiUrl + path,
			...config,
			validateStatus: function (status) {
				return status >= 200 && status < 600;
			},
		})
	};
}

const getLoggedinUser = () => {
	const user = Cookies.get('authUser');
	if (!user) {
		return null;
	} else {
		return JSON.parse(user);
	}
};

export { APIClient, setAuthorization, getLoggedinUser };